/**
 * Toast surface. Implemented over `sonner` per shadcn's "new-york" toast story.
 *
 * Usage:
 *   import { Toaster, toast } from '@/components/ui/toast';
 *   <Toaster />          // mount once in the app shell
 *   toast.success('Saved'); // call from anywhere
 */
import { Toaster as SonnerToaster, toast } from 'sonner';

const Toaster = SonnerToaster;

export { Toaster, toast };
